import React, { useState, useEffect } from 'react';
import Banner from '../homepage/banner';
import "braintree-web";
import axios from "axios";
import Loader from '../components/Loader';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ConnectionForm from './connection';
import Payment from './payment';
import OtpVerification from './otpVerification';
import { DropdownDate, } from 'react-dropdown-date';




const Checkout = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;
  const { state } = useLocation();
  const [activeTab, setActiveTab] = useState('Account');
  const [customerId, setCustmerId] = useState(null);
  const [orderDetails, setOrderDetails] = useState('');
  const [errors, setErrors] = useState({});
  const [isThankyourTab, setisThankyourTab] = useState(false)
  const [orderRefId, setorderRefId] = useState('');
  const [SelectedAddress, setSelectedAddress] = useState('');
  const [apiMessage, setApiMessage] = useState([]);
  const [apiStatus, setApiStatusCode] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [sal, setSal] = useState('');
  const [apiCalled, setApiCalled] = useState(false);
  const [orderStep, setOrderStep] = useState('account');
  const [submissionType, setSubmissionType] = useState('customer_details');
  const navigate = useNavigate();
  const [logedUserName, setLoggedInUserName] = useState(false);
  const [logedUserEmail, setLoggedInUserEmail] = useState(false);
  const [couponCodeDetails, setCounponCodeDetails] = useState({});
  const [loading, setLoading] = useState(false);




  const sessionVisp = state.vispID;

  const [formData, setFormData] = useState({
    sal: '',
    firstName: '',
    surname: '',
    email: '',
    contact_number: '',
    dob: '',
    visp_qualification_id: sessionVisp
  });

  const [error, setError] = useState('');
  useEffect(() => {
    fetchData();
    fetchSal();
    handleDateChange(getMaxDate());
    const releventDiv = document.getElementById('checkoutBox');
    releventDiv.scrollIntoView({ behavior: "smooth" });

  }, []);

  const [date, setDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const currentDate = new Date();
  const monthAbbreviation = currentDate.toLocaleString('default', { month: 'short' });
  const dayNumber = currentDate.getDate();
  const yearNumber = currentDate.getFullYear();
  const formattedDate = `${yearNumber} ${monthAbbreviation} ${dayNumber}`;


  const handleInputChange = (e) => {


    const { name, value } = e.target;
    if (name === 'firstName' || name === "surname") {
      if (/^[A-Za-z ]{0,60}$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value
        });
        setError('');
      } else if (value.length > 60) {
        setError('The first name format is invalid.');
        setTimeout(() => {
          setFormData({
            ...formData,
            [name]: value.slice(0, 60)
          });
        }, 2000);
      }
    } else if (name === 'contact_number') {
      if (/^\d{0,10}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }

    } else if (name === 'dob') {
      const enteredDate = new Date(value);
      const maxDate = new Date(getMaxDate());
      if (enteredDate > maxDate) {
        e.target.setCustomValidity('You must be over 18 years old to submit this form');
      } else {
        e.target.setCustomValidity('');
      }
      setFormData({ ...formData, [name]: value });
    } else {

      setFormData({
        ...formData,
        [name]: value
      });
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`${apiUrl}nbn_customer_sign_up`, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        setLoading(false)
        setApiCalled(true);
        setSessionId(response.data.data.session_id);
        setApiMessage(response.data.message);
        setApiStatusCode(response.data.status);
        setTimeout(() => {
          setApiCalled(false);
          openCity(e, 'otpVerification')
        }, 2000);
      })
      .catch(error => {
        setApiCalled(true);
        setApiStatusCode(false);

        const errorMessage = error.response.data.message;
        setApiMessage(errorMessage);
      })
      .finally(() => {
        setTimeout(() => {
          setApiCalled(false);
        }, 6000);
      });
  };


  async function fetchSal() {
    try {
      const response = await axios.get(apiUrl + 'customer_salutations', { headers: { 'api-token': apiKey } });
      if (response.status === 200) {
        setSal(response.data.data.salutations);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
  async function fetchData() {
    if (state) {
      const payload = {
        "visp_qualification_id": state.vispID,
        "plan_id": state.plan_id,
      };
      try {
        const response = await axios.post(apiUrl + 'check_order_details', payload, { headers: { 'api-token': apiKey } });
        console.log("check order detals", response)
        if (response.status === 200) {
          setSelectedAddress(response.data.data.inputAddress)
          setOrderDetails({
            plan_name: response.data.data.plan.plan_display_name,
            fixedSpeed: response.data.data.plan.plan_name,
            data: response.data.data.plan.data_text,
            website_amount: response.data.data.plan.website_sale_amount,
            contract_length: response.data.data.plan.validity_text,
            gst_amount: response.data.data.plan.gst_amount,
            gst_inclusive_sale_amount: response.data.data.plan.gst_inclusive_sale_amount
          });
        } else {
          throw new Error("Unexpected status code: " + response.status);
        }
      } catch (error) {
        console.error("Error occurred:", error);
        navigate("/")
      }
    }
  };

  const getMaxDate = () => {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear() - 18;

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  const changeCouponCodeDetails = (couponCode) => {
    setCounponCodeDetails(couponCode);
    console.log('couponCodeDetails------->',couponCodeDetails);
    console.log('couponCodeDetails------->',couponCodeDetails);
  }

  const changeTabActive = (e, activeTabName) => {
    setOrderStep(activeTabName)
  }



  const changeOrderRefId = (e, value) => {
    setorderRefId(e);
  }

  const openCity = (event, tabName) => {
    if (tabName === 'ThankYouPage') {
      setisThankyourTab('true')
    }
    setActiveTab(tabName);

  };
  const isFormValid = Object.keys(errors).length === 0;


  const [signInFormData, setsignInFormData] = useState({
    username: '',
    password: '',
    visp_qualification_id: sessionVisp
  });


  const handleSignFormInputChange = (e) => {
    const { name, value } = e.target;
    setsignInFormData({
      ...signInFormData,
      [name]: value
    });

  }

  const handleSignInSubmit = (e) => {

    e.preventDefault();


    axios.post(`${apiUrl}nbn_customer_sign_in`, signInFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        setApiCalled(true);

        setSessionId(response.data.data.session_id);
        setApiMessage(Array.isArray(response.data.message) ? response.data.message : [response.data.message]);
        setApiStatusCode(response.data.status);

        if (response.data.data.customer) {
          var name = response.data.data.customer.sal + " " + response.data.data.customer.firstName + " " + response.data.data.customer.surname;
          setLoggedInUserName(name);
          setLoggedInUserEmail(response.data.data.customer.email);
        }
        setOrderStep('connection')
        setTimeout(() => {
          setApiCalled(false);
          openCity(e, 'Connection')
        }, 2000);
      })
      .catch(error => {

        setApiStatusCode(false);
        setApiCalled(true);
        const errorMessage = error.response.data.message;
        setApiMessage(errorMessage);
      })
      .finally(() => {
        setTimeout(() => {
          setApiCalled(false);
        }, 2000);
      });

  };


  const formatDate = (date) => {
    // formats a JS date to 'yyyy-mm-dd'
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };


  const handleDateChange = (date) => {
    setDate(date);
    const formattedDate = formatDate(date);
    setSelectedDate(formattedDate);
    setFormData({
      ...formData,
      ['dob']: formattedDate
    });


  };


  function calculateEndYear() {
    const today = new Date();
    const currentYear = today.getFullYear();
    let endYear = currentYear - 18;
    return endYear;
  }

  const endYear = calculateEndYear();
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, '0'); // Adding 1 to get the month in range 1-12
  const currentDay = today.getDate();
  const formattedDay = currentDay < 10 ? `0${currentDay}` : currentDay;
  const startDate =`1924-01-01`;
  const endDate = `${endYear}-${currentMonth}-${formattedDay}`;
 //alert(endDate);

  return (
    <div>
      <Banner title="CHECKOUT" description="Get High-Speed Internet At Your Fingertips." />
      <div className="container">
        <section className="common-section">
          <div className="row">
            <div className="col-md-12">
              <div className="modem-card">
                <div className="row">
                  <div className="col-md-7">
                    <div className="formbold-form-wrapper">
                      <form>
                        <div className="formbold-steps">
                          <ul>
                            <li className={`formbold-step-menu2 ${orderStep === 'account' ? 'active1' : ''}`}>
                              <span>1</span>
                              Account <i className="fa fa-long-arrow-right icon-right" aria-hidden="true"></i>
                            </li>
                            <li className={`formbold-step-menu2 ${orderStep === 'connection' ? 'active1' : ''}`}>
                              <span>2</span>
                              Connection <i className="fa fa-long-arrow-right icon-right" aria-hidden="true"></i>
                            </li>
                            <li className={`formbold-step-menu2 ${orderStep === 'payment' ? 'active1' : ''}`}>
                              <span>3</span>
                              Payment
                            </li>
                          </ul>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-5 nbn-contact-info">
                    <strong>CALL US ON</strong>
                    <h3>1300-TELSIM (1300 835 746)</h3>
                  </div>
                </div>
              </div>
              <br /><br />
            </div>

            <div className="col-md-7" id="checkoutBox">
              <div className="modem-card">
                {isThankyourTab ? ('') :
                  <div className="tab">
                    {logedUserName && logedUserEmail ?
                      <button className="tablinks active loggedTab" style={{ width: '100%' }}>
                        <span style={{ display: 'block', textAlign: 'left' }}>Name : {logedUserName}</span>
                        <span style={{ display: 'block', textAlign: 'left' }}>Email : {logedUserEmail}</span>
                      </button>
                      :
                      <>
                        {
                          activeTab === 'Account' || activeTab === 'SignIn' ? <> <button className={activeTab === 'Account' ? "tablinks active" : "tablinks"} disabled={activeTab === 'Connection' || activeTab === 'Payment'} onClick={(e) => openCity(e, 'Account')}>New Account</button>
                            <button className={activeTab === 'SignIn' ? "tablinks active" : "tablinks"} disabled={activeTab === 'Connection' || activeTab === 'Payment'} onClick={(e) => openCity(e, 'SignIn')}>Sign In</button> </> : ''
                        }
                      </>
                    }
                  </div>
                }


                {activeTab === 'Account' && (
                  <div id="Account" className="tabcontent">
                    <section className="get-plan" style={{ marginTop: '0!important;' }}>
                      <div className="container" style={{ backgroundColor: '#fff', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}>
                        <h3 className="title" style={{ textAlign: 'center' }}>New Account</h3>
                        <p style={{ textAlign: 'center', color: '#777', marginTop: '-10px' }}>Enter your contact details</p><br />


                        <form className="contact-form row" onSubmit={handleSubmit}>
                          <div className="form-field col-lg-12">
                            <label className="label" htmlFor="mobile">Title</label>

                            <select name='sal' onChange={handleInputChange} value={formData.sal || ''}>
                              {sal ? (
                                <>
                                  <option value="" style={{ backgroundColor: '#f5f5f5' }}>Select Salutation</option>
                                  {sal.map((salutation) => (
                                    <option key={sal.salutation_id} value={salutation.salutation}>
                                      {salutation.salutation}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option value=""></option>
                              )}

                            </select>
                          </div>
                          <input type="hidden" name='type' value={submissionType} ></input>
                          <div className="form-field col-lg-12">
                            <label className="label" htmlFor="mobile">First Name</label>
                            <input type="text" autoComplete="off" className="input-text js-input" name="firstName" value={formData.firstName} onChange={handleInputChange} pattern="[A-Za-z ]{1,60}" />
                          </div>


                          <div className="form-field col-lg-12">
                            <label className="label" htmlFor="mobile">Surname</label>
                            <input type="text" autoComplete="off" className="input-text js-input" name="surname" value={formData.surname} onChange={handleInputChange} pattern="[A-Za-z ]{1,60}" />
                          </div>




                          <div className="form-field col-lg-12">
                            <label className="label" htmlFor="mobile">Contact Number</label>
                            <input type="phone" autoComplete="off" className="input-text js-input" name="contact_number" value={formData.contact_number} onChange={handleInputChange} min={0} max={9999999999} pattern="[0-9]{10}"
                            />
                          </div>
                          <br></br>
                          {/* <div className="form-field col-lg-12">
                            <label className="label" htmlFor="dobpik">Date of Birth <span>(DD/MM/YYYY)</span></label>
                            <input type="date" className="input-text2 js-input" id="dobpik" name="dob" value={formData.dob} onChange={handleInputChange} max={getMaxDate()} required style={{ outline: 'none' }} />
                          </div>  */}

                          <div className="form-field col-lg-12 prfActivationDate newDatePicker">
                            <label className="label ctm-padding" htmlFor="mobile">Date of Birth </label>

                            <DropdownDate
                              startDate={startDate}
                              endDate={endDate}
                              selectedDate={selectedDate}
                              onDateChange={handleDateChange}

                            />
                          </div>


                          <div className="form-field col-lg-12">
                            <input className="submit-btn" type="submit" disabled={apiCalled} value={apiCalled ? 'Loading...' : 'CONTINUE'} />
                          </div>
                        </form>




                        {apiCalled && apiMessage && (
                          <div className={"alert " + (apiStatus === 200 ? "alert-success" : "alert-danger")} style={{ textAlign: 'left' }}>
                            <strong>{apiStatus === 200 ? 'Please wait...' : ''}</strong>

                            {apiMessage.sal && (<strong style={{ display: 'block' }}>{apiMessage.sal}</strong>)}
                            {apiMessage.firstName && (<strong style={{ display: 'block' }}>{apiMessage.firstName}</strong>)}
                            {apiMessage.surname && (<strong style={{ display: 'block' }}>{apiMessage.surname}</strong>)}
                            {apiMessage.contact_number && (<strong style={{ display: 'block' }}>{apiMessage.contact_number}</strong>)}
                            {apiMessage.dob && (<strong style={{ display: 'block' }}>{apiMessage.dob}</strong>)}
                          </div>
                        )}

                        {error &&
                          <div className="alert alert-danger">
                            {error}
                          </div>
                        }
                      </div>
                    </section>
                  </div>
                )}

                {activeTab === 'otpVerification' && (
                  <OtpVerification sessionId={sessionId} visp_qualification_id={state.vispID} variable={formData} onBackClick={e => openCity(e, 'Account')} onActiveSuccess={e => changeTabActive(e, 'connection')} onSuccessTap={e => openCity(e, 'Connection')} ></OtpVerification>
                )}
                {activeTab === 'SignIn' && (
                  <div id="SignIn" className="tabcontent">
                    <section className="get-plan" style={{ marginTop: '0!important;' }}>
                      <div className="container" style={{ backgroundColor: '#fff', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}>
                        <h3 className="title">Sign-In</h3>
                        <p style={{ color: '#777', marginTop: '-10px' }}>Login to your account</p><br />
                        <form className="contact-form row" onSubmit={handleSignInSubmit}>
                          <div className="form-field col-lg-12">
                            <input type="email" autoComplete="off" className="input-text js-input" name="username" value={signInFormData.username} onChange={handleSignFormInputChange} required />
                            <label className="label" htmlFor="mobile">Username</label>
                          </div>
                          <div className="form-field col-lg-12">
                            <input type="password" autoComplete="off" className="input-text js-input" name="password" value={signInFormData.password} onChange={handleSignFormInputChange} required />
                            <label className="label" htmlFor="email">Password</label>
                          </div>
                          <div className="form-field col-lg-12">
                            <input className="submit-btn" type="submit" value="LOGIN" />
                          </div>
                        </form>

                        {apiCalled && (
                          <div>
                            {apiStatus === 200 ? (
                              <div className="alert alert-success">
                                <strong>Successfully Submitted!</strong> {apiMessage}
                              </div>
                            ) : (
                              <div className="alert alert-danger">
                                <strong>{apiMessage}</strong>
                              </div>
                            )}

                          </div>
                        )}
                      </div>
                      <a href="https://prepaid.telsim.com.au/ForgotUserId">Forgot username</a> or <span></span>
                      <a href="https://prepaid.telsim.com.au/ResetPassword">password</a>
                    </section>
                  </div>
                )}
                {activeTab === 'Connection' &&
                  <ConnectionForm vispID={state.vispID} address={SelectedAddress} onActiveSuccess={e => changeTabActive(e, 'payment')} onSuccess={e => openCity(e, 'Payment')} />
                }
                {activeTab === 'Payment' && (
                  <Payment customerId={customerId} Loader={Loader} state={state} onChangeOrderRefId={e => changeOrderRefId(e)} changeCouponCodeDetails={e => changeCouponCodeDetails(e)} onSuccessTap={e => openCity(e, 'ThankYouPage')} conditionAmount={(Number(orderDetails.gst_inclusive_sale_amount) + Number(state.gst_modem_amount) + Number(state.gst_shipping_charge)).toFixed(2)}  ></Payment>
                )}
                {activeTab === 'ThankYouPage' && (
                  <div className='thanks-section'>
                    <i class="fa fa-check-circle thanks-icon" aria-hidden="true"></i>
                    <h3>Thank You. Your order has been received.</h3>
                    <strong>Please check the email ID used during purchase for more details about the purchase.</strong><br />
                    <hr />
                    <h5>Order number : <span>{orderRefId}</span></h5>
                    <hr />
                    <h5>Date : <span>{formattedDate}</span></h5>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-5">
              <div className="modem-card">

                <h3>Your Order Summary</h3>
                <hr />
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Plan Name</td>
                      <th valign="top" style={{ textAlign: "left" }}>: {orderDetails.plan_name}</th>
                    </tr>
                    <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Speed Tier</td>
                      <th valign="top" style={{ textAlign: "left" }}>: {orderDetails.fixedSpeed} </th>
                    </tr>
                    <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Monthly Data</td>
                      <th valign="top" style={{ textAlign: "left" }}>: {orderDetails.data}  | ${orderDetails.website_amount} </th>
                    </tr>
                    {state.product_name &&
                      <>
                        <tr>
                          <td valign="top" style={{ textAlign: "left" }}>Modem </td>
                          <th valign="top" style={{ textAlign: "left" }}>: {state.product_name}  </th>
                        </tr>
                        <tr>
                          <td valign="top" style={{ textAlign: "left" }}>Modem + Shipping</td>
                          <th valign="top" style={{ textAlign: "left" }}>: ${(Number(state.product_amount) + Number(state.shipping_charge)).toFixed(2)}</th>
                        </tr>
                      </>
                    }
                    <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Contract Length</td>
                      <th valign="top" style={{ textAlign: "left" }}>: {orderDetails.contract_length}</th>
                    </tr>
                    {couponCodeDetails.voucher_name  !== undefined &&couponCodeDetails.voucher_name  !== null  && <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Promocode</td>
                      <th valign="top" style={{ textAlign: "left" }}>: {couponCodeDetails.voucher_name}</th>
                    </tr>}
                    {couponCodeDetails.nbn_voucher_discounted_amount !== undefined && couponCodeDetails.nbn_voucher_discounted_amount !== null && (
                      <tr>
                        <td valign="top" style={{ textAlign: "left" }}>Discount</td>
                        <th valign="top" style={{ textAlign: "left" }}>: ${Number(couponCodeDetails.nbn_voucher_discounted_amount).toFixed(2)}</th>
                      </tr>
                    )}

                    {couponCodeDetails.nbn_credit_added > 0  && couponCodeDetails.credit_amount !== null && (

                      <tr>
                        <td valign="top" style={{ textAlign: "left" }}>NBN credits added
                      </td>
                        <th valign="top" style={{ textAlign: "left" }}> :
                           ${couponCodeDetails.nbn_credit_added.toFixed(2)}
                        </th>
                      </tr>

                     )} 

                    <tr>
                      <td valign="top" style={{ textAlign: "left" }}>Total Upfront Costs</td>
                      <th valign="top" style={{ textAlign: "left" }}>
                        : {Number(couponCodeDetails.plan_gst_inclusive_sale_amount) < Number(orderDetails.gst_inclusive_sale_amount) ?
                          <>

                            ${(Number(couponCodeDetails.plan_gst_inclusive_sale_amount) + Number(state.gst_modem_amount) + Number(state.gst_shipping_charge)).toFixed(2)}
                          </>
                          :
                          <>
                            ${(Number(orderDetails.gst_inclusive_sale_amount) + Number(state.gst_modem_amount) + Number(state.gst_shipping_charge)).toFixed(2)}
                          </>

                        }
                        
                      </th>
                    </tr>
                  </thead>
                </table>
                {couponCodeDetails.nbn_credit_added > 0  && couponCodeDetails.credit_amount !== null && (
                <p><span style={{ color: 'red' }}> *</span> NBN credits can be used for future purchases.</p>
              )} 
                <p><span style={{ color: 'red' }}> * </span>All amounts mentioned are in AUD only</p>
                <div className="modem-bg">
                  {activeTab === 'ThankYouPage' ?
                    <h4 style={{ margin: "10px 0 0px 0" }}>Total Amount</h4>
                    :
                    <h4 style={{ margin: "10px 0 0px 0" }}>Your monthly total</h4>
                  }
                  {state.amount ? (
                    <h2>${orderDetails.website_amount}/Month <span></span></h2>
                  ) : (
                    <h2>0<span>/ mth</span></h2>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Checkout;